import Vue from 'vue';

const FULL_SCREEN_BUS_EVENTS = {
    STEP_CLICKED_IN_FULLSCREEN_MODE: 'STEP_CLICKED_IN_FULLSCREEN_MODE',
};
const fullScreenBus = new Vue();
export {fullScreenBus, FULL_SCREEN_BUS_EVENTS};